// extracted by mini-css-extract-plugin
export default {"container":"Overview_container__l8tTJ","headingContainer":"Overview_headingContainer__G5CBf","cardArea":"Overview_cardArea__tAnJ8"};